import type {CustomerLogo} from '@/ui/logos-carousel';

export const LOGO_BASE = '/static/images/industry-construction-and-engineering/customer-logos';

/** `file` matches basename in customer-logos/ (without .png). */
export const CUSTOMER_LOGOS: CustomerLogo[] = [
  {file: 'MI-homes', label: 'M/I Homes', width: 160, height: 80},
  {file: 'FHP', label: 'F.H. Paschen', width: 160, height: 80},
  {file: 'Consigli', label: 'Consigli', width: 160, height: 80},
  {file: 'Royal-electric', label: 'Royal Electric', width: 160, height: 80},
  {file: 'H&H', label: 'H&H', width: 120, height: 80},
  {file: 'ABM', label: 'ABM', width: 160, height: 80},
  {file: 'Marshalls', label: 'Marshalls', width: 160, height: 80},
  {file: 'Bridges', label: 'Bridges', width: 160, height: 80},
  {file: 'Firetrol', label: 'Firetrol', width: 160, height: 80},
  {file: 'TEiC', label: 'TEiC', width: 160, height: 80},
  {file: 'Hoffmann', label: 'Hoffmann', width: 160, height: 80},
  {file: 'Statom', label: 'Statom', width: 160, height: 80},
  {file: 'SimeDarby', label: 'Sime Darby', width: 160, height: 80},
  {file: 'Gek-terna', label: 'GEK Terna', width: 160, height: 80},
  {file: 'Labella', label: 'Labella', width: 160, height: 80},
  {file: 'GBI', label: 'GBI', width: 160, height: 80},
  {file: 'Crown', label: 'Crown', width: 160, height: 80},
  {file: 'Kiewit', label: 'Kiewit', width: 160, height: 80},
  {file: 'LGI', label: 'LGI', width: 160, height: 80},
  {file: 'Quiddity', label: 'Quiddity', width: 160, height: 80}
];
